import React, { useEffect, useState } from "react";
import { Card, Row, Col, Modal } from "react-bootstrap";
import { ChevronDown } from "lucide-react";

const AvatarSelection = ({
	loadedAvatars,
	value,
	onChange,
	onBlur,
	error,
	touched,
}) => {
	const [avatars, setAvatars] = useState([]);
	const [selectedAvatar, setSelectedAvatar] = useState(value?.avatarId || null);
	const [selectedLook, setSelectedLook] = useState(value?.lookId || null);
	const [showModal, setShowModal] = useState(false);
	const [looks, setLooks] = useState([]);
	const [hasBlurred, setHasBlurred] = useState(false);
	const [expanded, setExpanded] = useState(false);

	const handleBlur = () => {
		if (!selectedAvatar) {
			setHasBlurred(true);
			if (onBlur) {
				onBlur();
			}
		}
	};

	const handleCardClick = (avatar) => {
		setSelectedAvatar(avatar);
		setSelectedLook(null);
		setLooks(avatar.scenes || []);
		setShowModal(avatar.scenes.length > 1);

        if (avatar.scenes.length === 1) {
            setSelectedLook(avatar.scenes[0]);
            onChange({
                avatarId: avatar.id,
                lookId: avatar.scenes[0].id,
                thumbnail: avatar.scenes[0].image_url,
            });
        } else {
            // For avatars with multiple scenes, clear the selection until a scene is chosen
            onChange({
                avatarId: avatar.id,
                lookId: null,
                thumbnail: null,
            });
        }
		setHasBlurred(false);
	};

	const handleLookClick = (look) => {
		setSelectedLook(look);
		onChange({
			avatarId: selectedAvatar.id,
			lookId: look.id,
			thumbnail: look.image_url,
		});
		//setShowModal(false);
	};

	useEffect(() => {
		setAvatars(loadedAvatars);
	}, [loadedAvatars]);

	const handleExpandClick = () => {
		setExpanded(true);
	};

	let displayAvatars = avatars;
	const canExpand = avatars.length > 4 && !expanded;
	if (!expanded && avatars.length > 4) {
		// show only first 4
		displayAvatars = avatars.slice(0, 4);
	}

	return (
		<React.Fragment>
			<div
				style={{ whiteSpace: "nowrap" }}
				onBlur={handleBlur}
			>
				<p>Ratava Selection</p>
				<Row>
					{displayAvatars.map((avatar) => (
						<Col
							key={avatar.id}
							xs={3}
							sm={3}
							md={2}
							style={{ display: "inline-block", float: "none" }}
						>
							<Card
								className={selectedAvatar === avatar ? "border-primary" : ""}
								onClick={() => handleCardClick(avatar)}
								style={{ cursor: "pointer", margin: "5px", width: "100%" }}
							>
								<Card.Img
									variant="top"
									src={
										selectedAvatar?.id === avatar.id && value.thumbnail && value.avatarId === avatar.id
											? value.thumbnail
											: avatar.image_url
									}
									style={{
										width: "100%",
										height: "auto",
										objectFit: "cover",
										objectPosition: "center",
										aspectRatio: "1",
										WebkitTransform: "translateZ(0)",
										transform: "translateZ(0)"
									}}
								/>
								<Card.Body>
									<Card.Title
										style={{ fontSize: "0.8rem", textAlign: "center" }}
									>
										{avatar.avatar_name}
									</Card.Title>
								</Card.Body>
							</Card>
						</Col>
					))}
					{canExpand && (
						<Col
							xs={3}
							sm={3}
							md={2}
							style={{ display: "inline-block", float: "none" }}
						>
							<Card
								style={{
									cursor: "pointer",
									margin: "5px",
									width: "100%",
									display: "flex",
									alignItems: "center",
									justifyContent: "center",
									minHeight: "120px",
								}}
								onClick={handleExpandClick}
							>
								<Card.Body
									className="d-flex flex-column align-items-center justify-content-center text-muted"
									style={{ fontSize: "0.9rem" }}
								>
									<ChevronDown
										size={24}
										color="#6c757d"
										style={{ marginBottom: "4px" }}
									/>
									<span>View All</span>
								</Card.Body>
							</Card>
						</Col>
					)}
				</Row>
			</div>
			{touched && hasBlurred && error && (
				<div className="text-danger">{error}</div>
			)}
			<Modal show={showModal} onHide={() => setShowModal(false)} size="md">
				<Modal.Header closeButton>
					<Modal.Title>
						{`Select a scene for ${selectedAvatar?.avatar_name}` ||
							"Selected Avatar"}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					{looks.length > 0 ? (
						<div
							style={{
								maxWidth: "100%",
								maxHeight: "400px",
								overflowY: "auto",
								overflowX: "hidden",
								margin: "0 auto",
								padding: "0.5rem"
							}}
						>
							<Row xs={1} md={2} lg={2}>
								{looks.map((look) => (
									<Col key={look.id} className="mb-3 px-2">
										<Card
											className={`card-clickable ${
												selectedLook === look ? "border-primary" : ""
											}`}
											onClick={() => handleLookClick(look)}
											style={{
												width: "100%",
												borderWidth: selectedLook === look ? "2px" : "1px",
											}}
										>
											<Card.Img 
												src={look.image_url}
												style={{
													width: "100%",
													height: "auto",
													objectFit: "cover",
													objectPosition: "center",
													aspectRatio: "1",
													WebkitTransform: "translateZ(0)",
													transform: "translateZ(0)"
												}}
											/>
										</Card>
									</Col>
								))}
							</Row>
						</div>
					) : (
						<p>No looks available for this avatar</p>
					)}
				</Modal.Body>
			</Modal>
		</React.Fragment>
	);
};

export default AvatarSelection;
